import { gql } from '@apollo/client';

export const leasingExpenseTypeFragment = gql`
  fragment leasingExpenseType on LeasingExpenseType {
    expenseTypeId
    expenseCode
    expenseName
    mandatory
    linkedItemId
    linkedItemName
    vatId
    vatName
    currencyId
    currencyCode
    currencyValue
    isLogistic
    currencyPercent
    isActive
    formula
    autocalculate
    useFormula
    minValue
    maxValue
    periodicity
  }
`;
